<p>
  objective-detail works!
</p>
